<script>
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import FullCalendar from "@fullcalendar/vue";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import CommonTableComponent from "@/components/table.vue";
import tableSearch from "@/mixins/tableSearch";
import pagination from "@/mixins/pagination";
import TabReservations from "@/views/pages/project/schedule/reservation/index";
import datetime from "@/mixins/datetime";
import router from "@/mixins/router";
import user from "@/mixins/user";
import interactionPlugin from "@fullcalendar/interaction";
import ModalRegisterReservationCar from "@/views/pages/project/schedule/modals/ModalRegisterReservationCar.vue";
import ModalRegisterReservationStaff from "@/views/pages/project/schedule/modals/ModalRegisterReservationStaff.vue";
import ModalRegisterReservationFactory from "@/views/pages/project/schedule/modals/ModalRegisterReservationFactory.vue";
import ReservationTypeBadge from "@/components/Common/ReservationTypeBadge.vue";
import ReservationFrequencyTypeBadge from "@/components/Common/ReservationFrequencyTypeBadge.vue";
import systemCode from "@/mixins/systemCode";
import ZzReservationStatus2Badge from "@/components/Common/ZzReservationStatus2Badge.vue";
import ReservationSiteBadge from "@/components/Common/ReservationSiteBadge.vue";
import DatePicker from "vue2-datepicker";
import {BIconChevronDoubleLeft,BIconChevronLeft,BIconChevronDoubleRight,BIconChevronRight} from 'bootstrap-vue'
import ModalListDeliveryLetter from "@/views/pages/project/schedule/modals/ModalListDeliveryLetter.vue";
import ModalListWorkCertificate from "@/views/pages/project/schedule/modals/ModalListWorkCertificate.vue";
import Multiselect from "vue-multiselect";
import selectMultipleCarWithCheckbox from "@/views/pages/project/schedule/mixins/selectMultipleCarWithCheckbox";
import selectMultipleDepartmentOptionsCheckbox from "@/views/pages/project/schedule/mixins/selectMultipleDepartmentOptionsCheckbox";
import selectMultipleReservationStatus1Checkbox from "@/views/pages/project/schedule/mixins/selectMultipleReservationStatus1Checkbox";
import schedule from "./mixins/schedule";
import appConfig from "@/app.config.json";
import sweetAlert from "@/mixins/sweetAlert";
import ModalGoogleScheduleStaff from "@/views/pages/project/schedule/modals/ModalGoogleScheduleStaff.vue";
import moment from "moment";

const MIN_TIME_DEFAULT = "06:00:00";
const MAX_TIME_DEFAULT = "07:00:00";

const WORK_TYPE_COLOR = {
  "01": "#616161",
  "02": "#4285f4",
  "03": "#7cb342",
  "04": "#f6bf26",
  "05": "#f4511e",
  "06": "#891457",
  "07": "#a79b8e"
};

export default {
  name: 'ListSchedulesByCarManager',
  page: {
    title: "スケジュール一覧（配車用）",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    FullCalendar,
    CommonTableComponent,
    TabReservations,
    ModalRegisterReservationCar,
    ModalRegisterReservationStaff,
    ModalRegisterReservationFactory,
    ReservationTypeBadge,
    ReservationFrequencyTypeBadge,
    ZzReservationStatus2Badge,
    ReservationSiteBadge,
    DatePicker,
    BIconChevronDoubleLeft,
    BIconChevronLeft,
    BIconChevronDoubleRight,
    BIconChevronRight,
    ModalListDeliveryLetter,
    ModalListWorkCertificate,
    Multiselect,
    ModalGoogleScheduleStaff
  },
  mixins: [
    pagination,
    tableSearch,
    datetime,
    router,
    systemCode,
    user,
    selectMultipleCarWithCheckbox,
    schedule,
    sweetAlert,
    selectMultipleReservationStatus1Checkbox,
    selectMultipleDepartmentOptionsCheckbox
  ],
  data() {
    return {
      isLoading: false,
      dateRegister: this.getToday(),
      //optionDepartment: [],

      filters: {
        start_datetime: "",
        end_datetime: "",
        type: "car",
        department: "",
        zz_car_types_parent_id: [],
        zz_reservation_status_1_id: [],
        department_id: [],
        column: "department_id",
        dir: "ASC",
      },
      calendarOptions: {
        resourceOrder: 'index',
        plugins: [resourceTimelinePlugin, interactionPlugin],
        schedulerLicenseKey: process.env.VUE_APP_FULLCALENDAR_LICENSE_KEY,
        initialView: "resourceTimeline",
        visibleRange: {
          start: this.getToday(),
          end: this.addOrSubtractTimeFromDate(6, 'days', 'add', this.getToday(), 'YYYY-MM-DD 23:59:59')
        },
        locale: "ja",
        eventOrder: "start_hour",
        weekends: true,
        slotMinWidth: 180,
        slotMinTime: MIN_TIME_DEFAULT,
        slotMaxTime: MAX_TIME_DEFAULT,
        expandRows: true,
        contentHeight: 630,
        timeZone: "UTC",
        headerToolbar: false,
        resourceAreaWidth: "15%",
        resourceAreaColumns: [
          {
            field: "car",
            headerContent: "車両",
            headerClassNames: "font-size-18"
          }
        ],
        resourceLabelClassNames: "align-middle",
        dateClick: (info) => {
          this.handleRegister(info);
        },
        eventClick: (info) => {
          if (info.event.extendedProps.work_reservation_id) {
            return this.redirectRoute(
              'projects.work_reservations.schedule.detail',
              {
                work_reservation_id: info.event.extendedProps.work_reservation_id,
              },
              {
                source: 'calendar',
                schedule_id: info.event.extendedProps.schedule_id,
                zz_reservation_frequency_type_id: info.event.extendedProps.zz_reservation_frequency_type_id,
                tab:this.filters.type,
              },
              this.$route.query,
              'projects/work-reservations/schedules'
            )
          }
          if (info.event.extendedProps.car_predetermined_id) {
            this.handleCarPredeterminedClick(info);
          }
          if (info.event.extendedProps.staff_predetermined_id) {
            this.handleStaffPredeterminedClick(info);
          }
          if (info.event.extendedProps.factory_predetermined_id) {
            this.handleFactoryPredeterminedClick(info);
          }
          if (info.event.extendedProps.google_schedule_id) {
            this.handleGoogleScheduleClick(info);
          }
        },
        resources: [],
        events: [],
        eventDidMount: info => {
          this.handleEventDidMounted(info);
        },
        viewClassNames: (arg) => {
          this.changeWidth(arg.view.type);
        },
        // datesSet: this.handleDatesSet,
      },
      selectedDivision: "",
      filterOfCarAndStaff: [],
      sumStaff: 0,
      sumCar: 0,
      isCustomWeek: true,
      isEditCarPredetermined: true,
      isEditStaffPredetermined: true,
      isEditFactoryPredetermined: true,
      typeOfDatePicker: 'week',
      selectedDate: this.getToday(),
      calendarView: 'resourceTimeline',
    };
  },
  async created() {
    // await this.getData();
  },
  created() {
    //this.getData();
    //this.getOptionsDepartment();
  },
  methods: {
    async getData() {
      this.filters = {
        ...this.filters,
        //start_datetime: this.filters?.start_datetime || this.getToday(),
        //end_datetime:
        //  this.filters?.end_datetime || this.addOrSubtractTimeFromDate(6, 'days', 'add', this.getToday(), 'YYYY-MM-DD 23:59:59'),
      };
      this.isLoading = true;

      // 日跨ぎの予定を取得するため、表示日より少し前後の予定を含めておく
      // this.filtersを使ってしまうとタブ切り替えやフィルターの際にどんどん計算が積みあがってしまうため
      // 基準日付はselectedDateにする
      // this.filters.start_datetime = moment(this.filters.start_datetime).add(-2, 'days').format('YYYY-MM-DD');
      // this.filters.end_datetime = moment(this.filters.end_datetime).add(2, 'days').format('YYYY-MM-DD');
      this.filters.start_datetime = moment(this.selectedDate).format('YYYY-MM-DD');
      this.filters.end_datetime = moment(this.selectedDate).add(7, 'days').format('YYYY-MM-DD');

      const url = apiEndpoints.list_schedule_by_car();
      const { status, data } = await this.$http.get(url, this.filters);
      this.isLoading = false;

      if (status && Array.isArray(data.result)) {
        this.calendarOptions.resources = []
        this.calendarOptions.events = []

        switch (this.filters.type) {
          case "car":
            this.mapScheduleByCar(data.result);
            break;
          case "staff":
            this.mapScheduleByStaff(data.result);
            break;
          case "vendor":
            this.mapScheduleByVendor(data.result);
            break;
          default:
            break;
        }
        this.handleFilterOfCarAndStaff();
        this.customCalendar();
        const buttons = document.querySelectorAll(".confirm-button");
        buttons.forEach(button => button.addEventListener('click', this.beforeOnClickConfirmButton))

        const buttonsPrintDeliveryLetter = document.querySelectorAll(".confirm-button-print-delivery-letter");
        buttonsPrintDeliveryLetter.forEach(button => button.addEventListener('click', this.onClickConfirmButtonPrintDeliveryLetter))

        const buttonsPrintWorkCertificate = document.querySelectorAll(".confirm-button-print-work-certificate");
        buttonsPrintWorkCertificate.forEach(button => button.addEventListener('click', this.onClickConfirmButtonPrintWorkCertificate))
      }
    },
    //async getOptionsDepartment() {
      //const response = await this.$http.get(apiEndpoints.department_list_options, {
        //...this.filters,
      //});
      //const { status, data } = response;
      //if (status) {
        //this.optionDepartmentList = data.result;
      //}
    //},
    refreshSchedule(){
      this.getData();
    },
    mapScheduleByCar(data) {
      let resources = [],
        events = [];
      data.forEach((car, index) => {
        if (!resources.some(resource => resource.id == car.id)) {
          resources.push({
            index,
            id: car.id,
            car: car.name_with_number
          });
        }
        car.assigned_cars_by_schedule.map(item => {
          events.push({
            resourceId: car.id,
            ...this.eventObj(item)
          });
        });
        car.car_predetermined_schedules.map(item => {
          events.push({
            resourceId: car.id,
            zz_car_predetermined_schedule_type: item.zz_car_predetermined_schedule_type.car_predetermined_schedule_type ?? '',
            car_predetermined_title: item.title ?? '',
            car_predetermined_content: item.contents ?? '',
            car_predetermined_id: item.id ?? '',
            ...this.eventObj(item)
          });
        });
      });

      events.sort((a,b) => a.start_hour.localeCompare(b.start_hour));
      this.setCalendarOptions({ headerContent: "車両", resources, events });
    },
    mapScheduleByStaff(data) {
      let resources = [],
      events = [];
      data.forEach((staff, index) => {
        if (!resources.some(resource => resource.id == staff.id)) {
          resources.push({
            index,
            id: staff.id,
            car: staff.name_with_department
          });
        }
        staff.assigned_staffs_by_schedule.map(item => {
          events.push({
            resourceId: staff.id,
            ...this.eventObj(item)
          });
        });
        staff.google_schedule.map(item => {
          events.push({
            resourceId: staff.id,
            google_schedule_id: item.id ?? '',
            google_schedule_title: item.title ?? '',
            google_schedule_content: item.contents ?? '',
            google_schedule_is_all_day: item.is_all_day,
            ...this.eventObj(item)
          });
        });
        if(staff.staff_predetermined_schedule){
          staff.staff_predetermined_schedule.map(item => {
            events.push({
              resourceId: staff.id,
              staff_predetermined_title: item.title ?? '',
              staff_predetermined_content: item.contents ?? '',
              staff_predetermined_id: item.id ?? '',
              ...this.eventObj(item)
            });
          });
        }

      });

      events.sort((a,b) => a.start_hour.localeCompare(b.start_hour));
      this.setCalendarOptions({ headerContent: "従業員", resources, events });
    },
    mapScheduleByVendor(data) {
      let resources = [],
        events = [],
      eixsts = [];
      data.forEach((vendor_site, index) => {
        if (!resources.some(resource => resource.id == vendor_site.id)) {
          resources.push({
            index,
            id: vendor_site.id,
            car: vendor_site.name_abbreviated,
          })
        }
        vendor_site.disposal_sites.forEach(disposal_site_by_waste_category => {
          disposal_site_by_waste_category.disposal_site_by_waste.forEach(disposal_site_by_waste => {
            disposal_site_by_waste.schedules.forEach(schedule => {
              let vendor_site_id;
              let vendor_site_name = null;
              //get default vendor site id mapping
              vendor_site_id = vendor_site.id
              // 2 special case need to mapping name of factory to vendor site id
              // 排出の場合の排出事業場と委託先事業場のマッチングは API 側で行っているのでチェック不要
              // zz_discharger_site_4: 本社工場, vendor_sites.name_abbreviated: 静和本社工場 と異なるので後続の処理ではマッチングしない
              // if (schedule.zz_work_order_type_id === this.$constant.work_order_type.discharge) {
              //   //get name from zz_discharger_site_4 
              //   vendor_site_name = schedule.work_reservation?.work_order?.case?.discharger_site?.zz_discharger_site4?.discharger_site_4
              // }

              // 積替保管区間2も区間1の委託先事業場と同じものに含まれているのでここでのマッチングは不要
              // if (
              //   schedule.zz_work_order_type_id === this.$constant.work_order_type.transshipment_storage
              //   && parseInt(schedule.transport_and_hold_section) === 2
              // ) {
              //   //get name from zz_vendor_site_4
              //   let transport_contracts = schedule.work_reservation?.work_order?.transport_contracts[0];
              //   vendor_site_name = transport_contracts.vendor_site_id_section_1?.zz_vendor_site4?.vendor_site_4 || null
              // }
              // //if there is vendor_site_name exist from 2 special case then find factory for schedule
              // if (vendor_site_name) {
              //   vendor_site_id = data.find(vender_site_find => vender_site_find.name_abbreviated === vendor_site_name)?.id ?? null;
              // }
              let val = "";
              if (vendor_site_id) {
                // 既に同じ「事業場」「スケジュールID」「区間（作業分類）」を設定している場合は無視する
                let tmp = this.eventObj(schedule);
                val = vendor_site_id+'-'+tmp.schedule_id+'-'+tmp.work_order_type;
                if(!eixsts.includes(val)){
                  eixsts.push(val);
                  events.push({
                    resourceId: vendor_site_id,
                    ...tmp
                  });
                }
              }
            })
          })
        })
        if(vendor_site.factory_predetermined_schedule){
          vendor_site.factory_predetermined_schedule.map(item => {
            events.push({
              resourceId: vendor_site.id,
              factory_predetermined_title: item.title ?? '',
              factory_predetermined_content: item.contents ?? '',
              factory_predetermined_id: item.id ?? '',
              ...this.eventObj(item)
            });
          });
        }
      })

      events.sort((a,b) => a.start_hour.localeCompare(b.start_hour));
      this.setCalendarOptions({ headerContent: "工場", resources, events });
    },
    setCalendarOptions({ headerContent, resources, events }) {
      this.calendarOptions.resources = [];
      this.calendarOptions.events = [];
      this.calendarOptions.resources = resources.filter(
        (obj, index, self) => index === self.findIndex(t => t.id === obj.id)
      );
      this.calendarOptions.events = events;

      this.calendarOptions.resourceAreaColumns[0].headerContent = headerContent;
    },
    eventObj(schedule) {
      return {
        className: `event-schedule-${schedule.id ?? ''}`,
        schedule_id: schedule.id,
        start:
          (this.isCustomWeek ? this.formatDate(schedule.start_datetime) + ` ${MIN_TIME_DEFAULT}`
            : schedule.start_datetime) ?? "",
        end:
          (this.isCustomWeek ? this.formatDate(schedule.end_datetime) + ` ${MAX_TIME_DEFAULT}`
            : this.updateEndTimeDayLine(schedule.start_datetime, schedule.end_datetime)) ?? "",
        start_hour: this.formatDate(schedule.start_datetime, "HH:mm") ?? "",
        end_hour: this.formatDate(schedule.end_datetime, "HH:mm") ?? "",
        work_order_name: schedule.work_reservation?.work_order?.name ?? "",
        work_reservation_remarks: schedule.work_reservation?.remarks ?? "",
        work_order_type: this.getWorkOrderTypeBadge(schedule),
        work_order_type_id: schedule.zz_work_order_type?.id ?? "",
        discharger_name: schedule.work_reservation?.work_order?.case?.discharger?.name_abbreviated ?? "",
        discharger_site_name: schedule.work_reservation?.work_order?.case?.discharger_site?.name_abbreviated ?? "",
        discharger_site_user1_name: schedule.work_reservation?.work_order?.case?.discharger_site?.user1?.user_name ?? "",
        vendor: schedule.work_reservation?.work_order?.case?.vendor?.name_abbreviated ?? "",
        assigned_cars_by_schedule: schedule.assigned_cars_by_schedule ?? [],
        assigned_staffs_by_schedule: schedule.assigned_staffs_by_schedule ?? [],
        waste_or_services_by_schedule:
          schedule.waste_or_services_by_schedule ?? [],
        zz_reservation_status_1_id: schedule.zz_reservation_status_1_id ?? "",
        zz_reservation_status2: schedule.zz_reservation_status2 ?? "",
        schedule_id: schedule.id ?? "",
        schedule_id_tooltip: (schedule.id ?? "") + (+new Date * Math.random()).toString(36).substring(0,6),
        work_reservation_id: schedule.work_reservation_id ?? "",
        zz_reservation_site_id: schedule.zz_reservation_site_id ?? '',
        zz_reservation_type_id: schedule.zz_reservation_type_id ?? '',
        zz_reservation_frequency_type_id: schedule.zz_reservation_frequency_type_id ?? '',
        isHasDflex: !this.isCustomWeek
        ? !(this.getDiffTime(schedule.start_datetime,schedule.end_datetime, 'hours') < 3)
        : true,
        implements: schedule.work_reservation?.work_order?.implements ?? [],
        compliance_error: schedule.compliance_error ?? false,
      };
    },
    customCalendar() {
      let car_staff_status_info = document.getElementsByClassName(
        "car-staff-status-info"
      )[0];
      car_staff_status_info != undefined && car_staff_status_info.remove();

      let headDataGrid = document.getElementsByClassName(
        "fc-datagrid-cell font-size-18"
      )[0];
      let headerHour = document.getElementsByClassName(
        "fc-timeline-header-row-chrono"
      )[0];
      let headerDate = document.getElementsByClassName(
        "fc-timeline-header-row"
      )[0];

      if (this.isCustomWeek && headDataGrid && headerDate && headerHour) {
        headDataGrid.style.height = "56px";
        headerDate.style.display = null;
        headerDate.style.height = "56px";
        headerHour.style.display = "none";
      }

      let rowEvents = document.getElementsByClassName(
        "fc-timeline-slot fc-timeline-slot-lane fc-timeline-slot-major"
      );

      rowEvents.forEach(element => {
        let isRemoveColor =
          this.formatDate(element.dataset.date, "HH:mm:ss") !== "12:00:00";
        if (isRemoveColor) {
          element.style.borderRight = "none !important";
        }
      });

      let dateHeadTable = document.getElementsByClassName(
        "fc-timeline-slot fc-timeline-slot-label fc-day"
      );
      if (this.isCustomWeek) {
        dateHeadTable.forEach(el => {
          if (el.querySelector(".car-staff-status-info")) {
            el.querySelector(".car-staff-status-info").remove();
          }
          let infoCarAndStaff = () => {
            let element = '';
            let filterOfCarAndStaff = this.filterOfCarAndStaff.find(item => {
              return item.date == this.formatDate(el.dataset.date);
            });

            if (filterOfCarAndStaff && filterOfCarAndStaff.sum > 0) {
              element += `
            <div class="car-staff-status-info d-flex align-items-center justify-content-center">
              <div style="color:#0576b9; font-size: 14px; font-weight: bold;"></div>`;

                if (this.canUserEdit()) {
                  element += `<div class="d-flex align-items-center">`;

                    if (filterOfCarAndStaff.isConfirmed) {
                      element += `
                        <button
                          data-id="${filterOfCarAndStaff.schedule_id}"
                          data-date="${this.formatDate(filterOfCarAndStaff.date)}"
                          class="confirm-button-style confirm-button-print-delivery-letter btn btn-primary waves-effect waves-light font-size-12"
                        >
                          受渡確認票
                        </button>`;

                      element += `
                        <button
                          data-id="${filterOfCarAndStaff.schedule_id}"
                          data-date="${this.formatDate(filterOfCarAndStaff.date)}"
                          class="confirm-button-style confirm-button-print-work-certificate btn btn-primary waves-effect waves-light font-size-12"
                        >
                          自社伝票
                        </button>`;
                    }

                    if (filterOfCarAndStaff.isConfirmButton && this.isScheduleConfirmDate(filterOfCarAndStaff.date)) {
                      element += `
                        <button
                          data-id="${filterOfCarAndStaff.schedule_id}"
                          data-date="${this.formatDate(filterOfCarAndStaff.date)}"
                          class="confirm-button-style confirm-button btn btn-primary waves-effect waves-light font-size-12"
                        >
                          確定
                        </button>`;
                    }

                  element += `</div>`;
                }

              element += `</div>`;
            }

            return element;
          };
          el.insertAdjacentHTML("beforeend", infoCarAndStaff());

        });
      }
    },
    handleFilterOfCarAndStaff() {
      this.filterOfCarAndStaff = [];
      let date_range = this.getArrayOfDateRangeFromTo(
        this.filters.start_datetime,
        this.filters.end_datetime
      );
      date_range.forEach(date => {
        let sum = this.calendarOptions.resources.length;
        let events = this.calendarOptions.events.filter(
          event => this.formatDate(event.start) == date &&
                    (event.zz_reservation_status_1_id ? event.zz_reservation_status_1_id != 7 : true)
        );

        const calendarEvent = this.calendarOptions.events.filter(event => this.formatDate(event.start) == date && event.zz_reservation_status_1_id);
        const calendarEventConfirmed = calendarEvent.some(event => event.zz_reservation_status_1_id === '5');

        this.filterOfCarAndStaff.push({
          date: date,
          sum: sum ?? 0,
          inUse: events.length > sum ? sum : events.length,
          isConfirmButton: calendarEvent.length > 0,
          isConfirmed: calendarEventConfirmed,
          schedule_id: events[0]
            ? events[0].schedule_id
            : '',
        });
      });
    },
    handleEventDidMounted(info) {
      const EVENT_BG_COLOR = this.$constant.zzReservationStatus1BgColor

      if (info.event.extendedProps.work_order_type_id) {
        info.el.querySelector(".badge").style.backgroundColor =
          WORK_TYPE_COLOR[info.event.extendedProps.work_order_type_id];
      }
      if (info.event.extendedProps.car_predetermined_id 
      || info.event.extendedProps.google_schedule_id 
      || info.event.extendedProps.staff_predetermined_id 
      || info.event.extendedProps.factory_predetermined_id) {
        info.el.style.backgroundColor = 'white';
        info.el.style.borderColor = 'black';
      }
      if (info.event.extendedProps.zz_reservation_status_1_id) {
        info.el.style.backgroundColor =
          EVENT_BG_COLOR[info.event.extendedProps.zz_reservation_status_1_id];
        info.el.style.borderColor =
          EVENT_BG_COLOR[info.event.extendedProps.zz_reservation_status_1_id];
      }
      if(info.event.extendedProps.compliance_error){
        info.el.style.borderColor = 'red';
      }
    },
    //onChangeDivision(value) {
      //this.filters.zz_division = value;
      //this.getData();
    //},
   // onChangeDepartment(value) {
    //  this.filters.department = value;
     // this.getData();
    //},
    backToList() {
      const previousRoute = this.$route.params.previousRoute;
      this.$router.push({
        name: "projects",
        query: previousRoute && previousRoute.query ? previousRoute.query : {}
      });
    },
    beforeOnClickConfirmButton($event) {
      const eventDateMD = this.formatDate($event.target.dataset.date, 'M/D(dd)', 'ja');
      if (!eventDateMD) {
        return;
      }

      this.confirm(
        '',
        '',
        eventDateMD + ' の配車を確定してよろしいですか。',
        'warning',
        'OK',
        'キャンセル'
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.onClickConfirmButton($event, eventDateMD);
        }
      });
    },
    async onClickConfirmButton($event, eventDateMD) {
      console.trace();
      let el = $event.target;
      var listId = []
      let allEventIdAndStart = [];
      this.calendarOptions.events.forEach(function(event){
        let ev = [];
        ev.push(event.schedule_id);
        ev.push(event.start);
        allEventIdAndStart.push(ev);
      });
      let events = this.calendarOptions.events.filter(event => this.formatDate(event.start) == el.dataset.date);
      events.forEach(event => {

      if (event.car_predetermined_id 
      || event.google_schedule_id 
      || event.staff_predetermined_id 
      || event.factory_predetermined_id) {
        // 作業以外のスケジュールの場合ポストしない
      }else{
        if (event.schedule_id && !listId.some(item => item == event.schedule_id)) {
          listId.push(event.schedule_id);
        }
      }
      });

      const url = apiEndpoints.schedule_confirm();
      
      const { status, data } = await this.$http.post(url, {...this.filters, ids: listId, targetDate: el.dataset.date, allEventsLength: allEventIdAndStart.length});
      this.isLoading = false;
      const isSuccessDataExists = status && data.result && data.result.schedules && data.result.schedules.length;

      if (isSuccessDataExists) {
        // 確定したものがあれば再読み込み
        this.getData();
      }

      if (isSuccessDataExists && !data.result.contract_warning) {
        // コンプラチェックエラーなし & 確定したものあり  
        this.successToast(eventDateMD + " の配車を確定しました", false, 3000);
      } else {
        if (data.result.contract_warning) {
          // コンプラチェックエラーダイアログ表示
          this.$swal.fire({
            icon: "warning",
            html: data.result.contract_warning_message,
            width: data.result.width_alert || '70em',
          })
          .then(() => {
            // その後、確定したものがあればwarningのtoast表示
            if (isSuccessDataExists) {
              this.warningToast(eventDateMD + " の一部の配車が確定できませんでした", false, 3000);
            }
            // スケジュールの再読み込み
            this.getData();
          });
        }
      }

      listId = []
    },
    onClickConfirmButtonPrintDeliveryLetter($event) {
      let el = $event.target;
      let events = this.calendarOptions.events.filter(
        event => this.formatDate(event.start) == el.dataset.date && event.zz_reservation_status_1_id === '5'
      );

      if (events.length > 0) {
        this.$refs.listDeliveryLetter.openModal(events);
      }
    },
    onClickConfirmButtonPrintWorkCertificate ($event) {
      let el = $event.target;
      let events = this.calendarOptions.events.filter(
        event => this.formatDate(event.start) == el.dataset.date && event.zz_reservation_status_1_id === '5'
      );

      if (events.length > 0) {
        this.$refs.listWorkCertificate.openModal(events);
      }
    },
    typeBtnScheduleConfirm(type) {
      let filterOfCarAndStaff = this.filterOfCarAndStaff.find(item => {
        return item.date == this.formatDate(this.selectedDate);
      });

      if (filterOfCarAndStaff && filterOfCarAndStaff.sum) {
        if (
          filterOfCarAndStaff.isConfirmButton
          && this.isFutureAndPresent(filterOfCarAndStaff.date)
          && this.canUserEdit()
          && this.calendarView === 'resourceTimelineDay'
        ) {
          if (type === 'get') return filterOfCarAndStaff.schedule_id;

          return true;
        }
      }

      return false;
    },
    typeBtnScheduleConfirmPrint(type) {
      let filterOfCarAndStaff = this.filterOfCarAndStaff.find(item => {
        return item.date == this.formatDate(this.selectedDate);
      });

      if (filterOfCarAndStaff && filterOfCarAndStaff.sum) {
        if (
          filterOfCarAndStaff.isConfirmed
          && this.canUserEdit()
          && this.calendarView === 'resourceTimelineDay'
        ) {
          if (type === 'get') return filterOfCarAndStaff.schedule_id;

          return true;
        }
      }

      return false;
    },
    handleRegister(info){
      if(this.filters.type == 'car'){
        this.handleRegisterCar(info);
      }else if(this.filters.type == 'staff'){
        this.handleRegisterStaff(info);
      }else if(this.filters.type == 'vendor'){
        this.handleRegisterFactory(info);
      }
    },
    handleRegisterCar(info) {
      if (
        this.calendarOptions.resources.length > 0
        && this.isFutureAndPresent(info.date)
      ) {
        this.dateRegister = this.formatDate(info.date)
        this.$refs.modal_register_schedule_car.openModal({
          id: info.resource.id,
          name: info.resource.extendedProps.car
        },null, this.dateRegister);
      }
    },
    handleRegisterStaff(info) {
      if (
        this.calendarOptions.resources.length > 0
        && this.isFutureAndPresent(info.date)
      ) {
        this.dateRegister = this.formatDate(info.date)
        this.$refs.modal_register_schedule_staff.openModal({
          id: info.resource.id,
          user_name: info.resource.extendedProps.car.substring(0,info.resource.extendedProps.car.indexOf("\n"))
        },null, this.dateRegister);
      }
    },
    handleRegisterFactory(info) {
      if (
        this.calendarOptions.resources.length > 0
        && this.isFutureAndPresent(info.date)
      ) {
        this.dateRegister = this.formatDate(info.date)
        // carに入れてるのでcarからとる…元をいじると怖いので
        this.$refs.modal_register_schedule_factory.openModal({
          id: info.resource.id,
          name: info.resource.extendedProps.car
        },null, this.dateRegister);
      }
    },
    handleCarPredeterminedClick(info) {
      if (info.event.extendedProps.zz_car_predetermined_schedule_type) {
        const carPredeterminedId = info.event.extendedProps.car_predetermined_id;
        this.$refs.modal_register_schedule_car.openModal(null, carPredeterminedId);
      }
    },
    handleStaffPredeterminedClick(info) {
      if (info.event.extendedProps.staff_predetermined_id) {
        const staffPredeterminedId = info.event.extendedProps.staff_predetermined_id;
        this.$refs.modal_register_schedule_staff.openModal(null, staffPredeterminedId);
      }
    },
    handleFactoryPredeterminedClick(info) {
      if (info.event.extendedProps.factory_predetermined_id) {
        const factoryPredeterminedId = info.event.extendedProps.factory_predetermined_id;
        this.$refs.modal_register_schedule_factory.openModal(null, factoryPredeterminedId);
      }
    },
    handleGoogleScheduleClick(info) {
      if (info.event.extendedProps.google_schedule_id) {
        const infoGoogleSchedule = {
          id: info.event.extendedProps.google_schedule_id,
          title: info.event.extendedProps.google_schedule_title,
          start_date: this.formatDate(info.event.start),
          end_date: this.formatDate(info.event.end),
          start_hour: info.event.extendedProps.start_hour,
          end_hour: info.event.extendedProps.end_hour,
          content: info.event.extendedProps.google_schedule_content,
          is_all_day: info.event.extendedProps.google_schedule_is_all_day,
        };
        this.$refs.modal_google_schedule_staff.openModal(infoGoogleSchedule);
      }
    },
    updateEndTimeDayLine(start_datetime, end_datetime) {
      let start_hour = this.formatDate(start_datetime, 'HH')
      let end_hour = this.formatDate(end_datetime, 'HH')
      let end_minute = this.formatDate(end_datetime, 'mm')
      start_hour == end_hour && end_hour + 1

      return this.formatDate(end_datetime) + ` ${end_hour}:${end_minute === '00' ? '00' : end_minute}:00`
    },
    changeWidth(type) {
      if (type === 'resourceTimelineDay') {
        this.calendarOptions.slotMinWidth = 0
      } else {
        this.calendarOptions.slotMinWidth = 180
      }
    },
    onChangeFiltersType(type) {
      this.filters.type = type;
    },
    onChangeView(mode) {
      this.calendarView = mode;
      let calendarApi = this.$refs.fullcalendar.getApi();
      calendarApi.changeView(mode);

      if (this.calendarView === 'resourceTimelineDay') {
        this.$nextTick(() => {
          this.calendarOptions.slotMinTime = this.findTimezoneStart().system_code_value || '07:00:00';
          this.calendarOptions.slotMaxTime = this.findTimezoneEnd().system_code_value || '20:00:00';
        })
      } else {
        this.$nextTick(() => {
          this.calendarOptions.slotMinTime = MIN_TIME_DEFAULT;
          this.calendarOptions.slotMaxTime = MAX_TIME_DEFAULT;
        })
      }

      this.showCalendarView(calendarApi);
    },
    showCalendarView(calendarApi) {
      if (this.calendarView === 'resourceTimeline') {
        this.filters.start_datetime = this.addOrSubtractTimeFromDate(0, 'days', 'add', this.selectedDate, 'YYYY-MM-DD HH:mm:ss')
        this.filters.end_datetime = this.addOrSubtractTimeFromDate(6, 'days', 'add', this.selectedDate, 'YYYY-MM-DD 23:59:59')

        calendarApi.setOption('visibleRange', { start: this.filters.start_datetime, end: this.filters.end_datetime });
      } else {
        calendarApi.gotoDate(this.selectedDate);

        this.filters.start_datetime = this.addOrSubtractTimeFromDate(0, 'days', 'add', this.selectedDate, 'YYYY-MM-DD HH:mm:ss')
        this.filters.end_datetime = this.addOrSubtractTimeFromDate(0, 'days', 'add', this.selectedDate, 'YYYY-MM-DD 23:59:59')
      }

      this.getData();
    },
    gotoDoublePrev() {
      this.handleBtnDoubleNextOrPrevCalendar('subtract');
    },
    gotoPrev() {
      this.handleBtnNextOrPrevCalendar('subtract');
    },
    gotoToday() {
      this.selectedDate = this.getToday();
      let calendarApi = this.$refs.fullcalendar.getApi();

      this.showCalendarView(calendarApi);
    },
    gotoNext() {
      this.handleBtnNextOrPrevCalendar('add');
    },
    gotoDoubleNext() {
      this.handleBtnDoubleNextOrPrevCalendar('add');
    },
    handleBtnNextOrPrevCalendar(operationType) {
      if (this.calendarView === 'resourceTimelineDay') {
        const startHour = this.addOrSubtractHours(this.calendarOptions.slotMinTime, 1, operationType);
        const endHour = this.addOrSubtractHours(this.calendarOptions.slotMaxTime, 1, operationType);

        if (startHour && endHour) {
          this.$nextTick(() => {
            this.calendarOptions.slotMinTime = startHour;
            this.calendarOptions.slotMaxTime = endHour;
          })

          this.getData();
        }
      } else {
        let calendarApi = this.$refs.fullcalendar.getApi();
        this.selectedDate = this.addOrSubtractTimeFromDate(1, 'days', operationType, this.selectedDate, 'YYYY-MM-DD');

        this.showCalendarView(calendarApi);
      }
    },
    handleBtnDoubleNextOrPrevCalendar(operationType) {
      let calendarApi = this.$refs.fullcalendar.getApi();
      this.selectedDate = this.addOrSubtractTimeFromDate(this.durationOnCalendarView, 'days', operationType, this.selectedDate, 'YYYY-MM-DD');

      this.showCalendarView(calendarApi);
    },
    onChangeSelectedDate() {
      let calendarApi = this.$refs.fullcalendar.getApi();

      this.showCalendarView(calendarApi);
    },
    redirectProject() {
      this.$router.push({
        name: "projects.schedules.register_by_work_order.select_waste_or_service"
      });
    },
    btnColorFiltersType(type) {
      if (this.filters.type === type) {
        return 'primary';
      }

      return 'dark';
    },
    btnColorCalendarView(view) {
      if (this.calendarView === view) {
        return 'primary';
      }

      return 'dark';
    },
    // スケジュール枠内の作業分類バッジのラベル
    getWorkOrderTypeBadge(schedule) {
      if (!schedule.zz_work_order_type) {
        return '';
      }

      if (schedule.zz_work_order_type_id === this.$constant.work_order_type.transshipment_storage) {
        // 積替保管の場合は末尾に区間を付与
        let section = ''
        if (schedule.transport_and_hold_section === 1) {
          section = '１';
        } else if (schedule.transport_and_hold_section === 2) {
          section = '２';
        }
        return schedule.zz_work_order_type.work_order_type + section;
      }

      return schedule.zz_work_order_type.work_order_type;
    }
  },
  computed: {
    zzDivisions() {
      return this.$store.getters["options/options_tables"].zz_divisions ?? [];
    },
    durationOnCalendarView() {
      return this.calendarView === 'resourceTimeline' ? 7 : 1;
    },
    isViewTypeStaff(){
      return (this.filters.type == 'staff');
    }
  },
  watch: {
    'filters.type'(value) {
      this.getData()
    },
    '$route' (to, from) {
      this.getData();
    },
    calendarView: {
      handler(val) {
        if (val === 'resourceTimeline') {
          this.isCustomWeek = true;
        } else {
          this.isCustomWeek = false;
        }
      },
      immediate: true,
    },
  },
  activated() {
    this.refreshSchedule();
  },
};
</script>

<template>
  <Layout>
    <b-card class="custom-card">
      <b-row>
        <b-col class="mb-3" cols="12">
          <b-row>
            <b-col sm="auto">
              <b-button-group>
                <b-button :variant="btnColorFiltersType('car')" @click="onChangeFiltersType('car')">車両</b-button>
                <b-button :variant="btnColorFiltersType('staff')" @click="onChangeFiltersType('staff')">従業員</b-button>
                <b-button :variant="btnColorFiltersType('vendor')" @click="onChangeFiltersType('vendor')">工場</b-button>
              </b-button-group>
            </b-col>
            <b-col sm="auto">
              <b-button-group>
                <b-button :variant="btnColorCalendarView('resourceTimeline')" @click="onChangeView('resourceTimeline')">
                  週
                </b-button>
                <b-button :variant="btnColorCalendarView('resourceTimelineDay')"
                          @click="onChangeView('resourceTimelineDay')">日
                </b-button>
              </b-button-group>
            </b-col>
            <b-col sm="auto">
              <b-button-group>
                <b-button variant="dark" @click="gotoDoublePrev()">
                  <b-icon-chevron-double-left variant="white"/>
                </b-button>
                <b-button variant="dark" @click="gotoPrev()">
                  <b-icon-chevron-left variant="white"/>
                </b-button>
              </b-button-group>
            </b-col>
            <b-col sm="auto">
              <b-button variant="dark" size="df" @click="gotoToday()" :disabled="this.isToday(selectedDate)">今日
              </b-button>
            </b-col>
            <b-col sm="auto">
              <date-picker
                lang="ja"
                v-model="selectedDate"
                :clearable="false"
                placeholder="YYYY-MM-DD"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                position="left"
                type="date"
                @change="onChangeSelectedDate"
              ></date-picker>
            </b-col>
            <b-col sm="auto">
              <b-button-group>
                <b-button variant="dark" @click="gotoNext()">
                  <b-icon-chevron-right variant="white"/>
                </b-button>
                <b-button variant="dark" @click="gotoDoubleNext()">
                  <b-icon-chevron-double-right variant="white"/>
                </b-button>
              </b-button-group>
            </b-col>
            <b-col sm="auto" v-if="typeBtnScheduleConfirmPrint()">
              <b-button
                class="confirm-button-print-delivery-letter"
                variant="primary"
                size="df"
                :data-id="typeBtnScheduleConfirmPrint('get')"
                :data-date="selectedDate"
                @click="onClickConfirmButtonPrintDeliveryLetter($event)"
              >受渡確認票
              </b-button>
            </b-col>
            <b-col sm="auto" v-if="typeBtnScheduleConfirmPrint()">
              <b-button
                class="confirm-button-print-work-certificate"
                variant="primary"
                size="df"
                :data-id="typeBtnScheduleConfirmPrint('get')"
                :data-date="selectedDate"
                @click="onClickConfirmButtonPrintWorkCertificate($event)"
              >自社伝票
              </b-button>
            </b-col>
            <b-col sm="auto" v-if="typeBtnScheduleConfirm()">
              <b-button
                class="confirm-button"
                variant="primary"
                size="df"
                :data-id="typeBtnScheduleConfirm('get')"
                :data-date="selectedDate"
                @click="beforeOnClickConfirmButton($event)"
              ><i class='fas fa-check'></i> 確定
              </b-button>
            </b-col>
            <b-col sm="auto" class="multiple-select-custom" v-if="filters.type === 'staff'">
              <Multiselect
                :options="optionDepartment"
                :multiple="true"
                v-model="selectedDepartmentOptions"
                @input="onChangeDepartment"
                placeholder=""
                :close-on-select="false"
                group-values="attributes"
                group-label="selectAll"
                label="name"
                track-by="id"
                :group-select="true"
                selectLabel=""
                selectGroupLabel=""
                deselectLabel=""
                deselectGroupLabel=""
                selectedLabel=""
              >
                <template #option="props">
                  <div class="option__desc d-flex align-items-center gap-2" v-if="props.option['$groupLabel']">
                    <input type="checkbox" @click.self.prevent="checkDepartmentCheckedAll()"
                           id="name_all" :checked="checkDepartmentCheckedAll()">
                    <span class="option__small">{{ props.option.$groupLabel }}</span>
                  </div>
                  <div class="option__desc d-flex align-items-center gap-2" v-else>
                    <input type="checkbox" :id="`name_${props.option.id}`"
                           :checked="checkDepartmentChecked(props.option)">
                    <span class="option__small">{{ props.option.name }}</span>
                  </div>
                </template>
                <template #selection="{ values, search, isOpen }">
                  <span class=""
                        v-if="values.length == 0 || selectedDepartmentOptions.length == optionDepartment[0].attributes.length"
                  >所属：全て</span>
                  <span class="multiselect__single"
                        v-if="values.length && values.length != optionDepartment[0].attributes.length"
                  >{{ selectedDepartmentOptions.map(item => item.name).join('、') }}</span>
                </template>
              </Multiselect>
            </b-col>
            <b-col sm="auto" class="multiple-select-custom" v-if="filters.type === 'car'">
              <Multiselect
                :options="zzCarTypesParent"
                :multiple="true"
                v-model="selectedCarTypeParent"
                @input="onChangeCarTypeParent"
                placeholder=""
                :close-on-select="false"
                group-values="attributes"
                group-label="selectAll"
                label="car_types_parent"
                track-by="id"
                :group-select="true"
                selectLabel=""
                selectGroupLabel=""
                deselectLabel=""
                deselectGroupLabel=""
                selectedLabel=""
              >
                <template #option="props">
                  <div class="option__desc d-flex align-items-center gap-2" v-if="props.option['$groupLabel']">
                    <input type="checkbox" @click.self.prevent="checkCarCheckedAll()" id="car_types_parent_all"
                           :checked="checkCarCheckedAll()">
                    <span class="option__small">{{ props.option.$groupLabel }}</span>
                  </div>
                  <div class="option__desc d-flex align-items-center gap-2" v-else>
                    <input type="checkbox" :id="`car_types_parent_${props.option.id}`"
                           :checked="checkCarChecked(props.option)">
                    <span class="option__small">{{ props.option.car_types_parent }}</span>
                  </div>
                </template>
                <template #selection="{ values, search, isOpen }">
                  <span class=""
                        v-if="values.length == 0 || selectedCarTypeParent.length == zzCarTypesParent[0].attributes.length"
                  >車両タイプ: 全て</span>
                  <span class="multiselect__single"
                        v-if="values.length && values.length != zzCarTypesParent[0].attributes.length"
                  >{{ selectedCarTypeParent.map(item => item.car_types_parent).join('、') }}</span>
                </template>
              </Multiselect>
            </b-col>
            <b-col sm="auto" class="multiple-select-custom">
              <Multiselect
                :options="zzReservationStatus1"
                :multiple="true"
                v-model="selectedReservationStatus1"
                @input="onChangeReservationStatus"
                placeholder=""
                :close-on-select="false"
                group-values="attributes"
                group-label="selectAll"
                label="reservation_status_1"
                track-by="id"
                :group-select="true"
                selectLabel=""
                selectGroupLabel=""
                deselectLabel=""
                deselectGroupLabel=""
                selectedLabel=""
              >
                <template #option="props">
                  <div class="option__desc d-flex align-items-center gap-2" v-if="props.option['$groupLabel']">
                    <input type="checkbox" @click.self.prevent="checkedAllReservationStatus()"
                           id="reservation_status_1_all" :checked="checkedAllReservationStatus()">
                    <span class="option__small">{{ props.option.$groupLabel }}</span>
                  </div>
                  <div class="option__desc d-flex align-items-center gap-2" v-else>
                    <input type="checkbox" :id="`reservation_status_1_${props.option.id}`"
                           :checked="checkedReservationStatus(props.option)">
                    <span class="option__small">{{ props.option.reservation_status_1 }}</span>
                  </div>
                </template>
                <template #selection="{ values, search, isOpen }">
                  <span class=""
                        v-if="values.length == 0 || selectedReservationStatus1.length == zzReservationStatus1[0].attributes.length"
                  >状態: 全て</span>
                  <span class="multiselect__single"
                        v-if="values.length && values.length != zzReservationStatus1[0].attributes.length"
                  >{{ selectedReservationStatus1.map(item => item.reservation_status_1).join('、') }}</span>
                </template>
              </Multiselect>
            </b-col>
            <b-col sm="auto" v-if="false">
              <b-button variant="dark" size="df" @click="redirectProject()">
                <i class="fas fa-pencil-alt"></i> 予約登録
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <b-overlay
            :show="isLoading"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="d-inline-block w-100"
          >
            <FullCalendar :options="calendarOptions" ref="fullcalendar">
              <template v-slot:eventContent="arg">
                <div :id="`event-schedule-${arg.event.extendedProps.schedule_id_tooltip}`">
                  <div
                    v-if="arg.event.extendedProps.google_schedule_is_all_day != '1'"
                    :class="arg.event.extendedProps.isHasDflex ? 'd-flex align-items-center justify-content-start' : 'text-center'"
                  >
                    <div class="text-dark me-1" :class="arg.event.extendedProps.isHasDflex && 'text-nowrap'">
                      {{ arg.event.extendedProps.start_hour }} -
                      {{ arg.event.extendedProps.end_hour }}
                    </div>
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.google_schedule_title">
                    {{ arg.event.extendedProps.google_schedule_title }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.google_schedule_content">
                    {{ arg.event.extendedProps.google_schedule_content }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.zz_car_predetermined_schedule_type">
                    {{ arg.event.extendedProps.zz_car_predetermined_schedule_type }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.car_predetermined_title">
                    {{ arg.event.extendedProps.car_predetermined_title }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.car_predetermined_content"
                       v-html="arg.event.extendedProps.car_predetermined_content">
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.staff_predetermined_title">
                    {{ arg.event.extendedProps.staff_predetermined_title }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.staff_predetermined_content"
                       v-html="arg.event.extendedProps.staff_predetermined_content">
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.factory_predetermined_title">
                    {{ arg.event.extendedProps.factory_predetermined_title }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.factory_predetermined_content"
                       v-html="arg.event.extendedProps.factory_predetermined_content">
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.discharger_name">
                    {{ arg.event.extendedProps.discharger_name }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.discharger_site_name">
                    {{ arg.event.extendedProps.discharger_site_name }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.vendor">
                    {{ arg.event.extendedProps.vendor }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.work_order_name">
                    {{ arg.event.extendedProps.work_order_name }}
                  </div>
                  <div
                    class="text-dark" v-if="arg.event.extendedProps.waste_or_services_by_schedule"
                  >
                    {{ getWasteOrServiceName(arg.event.extendedProps.waste_or_services_by_schedule) }}
                  </div>
                  <div
                    class="text-dark" v-if="arg.event.extendedProps.waste_or_services_by_schedule"
                  >
                    {{ getVendorName(arg.event.extendedProps.waste_or_services_by_schedule) }}
                  </div>
                  <div class="flex-wrap d-flex mb-1 gap-1">
                    <div class="badge font-size-12 work-order-type-badge" v-if="arg.event.extendedProps.work_order_type">
                      {{ arg.event.extendedProps.work_order_type }}
                    </div>
                    <ReservationSiteBadge
                      v-if="!arg.event.extendedProps.zz_car_predetermined_schedule_type && !arg.event.extendedProps.google_schedule_id"
                      :reservation-site-id="arg.event.extendedProps.zz_reservation_site_id"
                    />
                    <ReservationTypeBadge
                      :reservation-type-id="arg.event.extendedProps.zz_reservation_type_id"
                    />
                    <ReservationFrequencyTypeBadge
                      :reservation-frequency-type-id="arg.event.extendedProps.zz_reservation_frequency_type_id"
                    />
                    <ZzReservationStatus2Badge
                      v-if="arg.event.extendedProps.zz_reservation_status2"
                      :badgeType="`calendar`"
                      :status-label="arg.event.extendedProps.zz_reservation_status2.reservation_status_2"
                      :status-id="arg.event.extendedProps.zz_reservation_status2.id"
                    />
                  </div>
                  <div
                    class="text-dark" v-if="arg.event.extendedProps.waste_or_services_by_schedule"
                  >
                    {{ getWasteManifestPreparationRole(arg.event.extendedProps.waste_or_services_by_schedule) }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.assigned_cars_by_schedule && isViewTypeStaff"
                  >
                    {{ getAssignCarName(arg.event.extendedProps.assigned_cars_by_schedule) }}
                  </div>
                  <div class="text-dark">
                    {{
                      getAssignStaffName(arg.event.extendedProps
                        .assigned_staffs_by_schedule)
                    }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.schedule_id" style="width:100%;text-align:right;">
                    [{{ arg.event.extendedProps.schedule_id }}]
                  </div>
                </div>
                <!-- Start ToolTip area -->
                <b-tooltip
                  custom-class="schedule-tooltip-custom"
                  :target="`event-schedule-${arg.event.extendedProps.schedule_id_tooltip}`"
                  triggers="hover"
                  placement="right"
                  v-if="!arg.event.extendedProps.car_predetermined_title && !arg.event.extendedProps.google_schedule_id"
                >
                  <div
                    class="text-dark" v-if="arg.event.extendedProps.waste_or_services_by_schedule"
                  >
                    {{ getWasteOrServiceNameWithQuantity(arg.event.extendedProps.waste_or_services_by_schedule) }}
                  </div>
                  <div
                    class="text-dark" v-if="arg.event.extendedProps.waste_or_services_by_schedule"
                  >
                    {{ getVendorNameForTooltip(arg.event.extendedProps.waste_or_services_by_schedule) }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.work_reservation_remarks">
                    {{ arg.event.extendedProps.work_reservation_remarks }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.discharger_site_user1_name">
                    {{ arg.event.extendedProps.discharger_site_user1_name }}
                  </div>
                  <div class="text-dark" v-if="arg.event.extendedProps.assigned_cars_by_schedule">
                    {{ getAssignCarName(arg.event.extendedProps.assigned_cars_by_schedule) }}
                  </div>
                  <div class="text-dark preline" v-if="arg.event.extendedProps.waste_or_services_by_schedule">
                    {{ getNumberOfRentalContainers(arg.event.extendedProps.waste_or_services_by_schedule) }}
                  </div>
                  <div class="text-dark preline" v-if="arg.event.extendedProps.waste_or_services_by_schedule">
                    {{ getCommentToUser(arg.event.extendedProps.waste_or_services_by_schedule) }}
                  </div>
                </b-tooltip>
              </template>
            </FullCalendar>
          </b-overlay>
        </b-col>
        <div :class="`button-collapse in`" v-b-toggle.sidebar-right>
          <div class="" style="margin-left: 5px;">
            <span class="fa fa-chevron-left fa-lg cursor-pointer"></span>
          </div>
          <div class="title mt-2 headline-type-1 headline-small">予約一覧の表示</div>
        </div>
        <b-sidebar no-close-on-route-change id="sidebar-right" bg-variant="white" title="" right shadow>
          <TabReservations class="tab-reservations"/>
        </b-sidebar>
      </b-row>
    </b-card>
    <ModalRegisterReservationCar
      ref="modal_register_schedule_car"
      :isEdit="isEditCarPredetermined"
      @closeModal="refreshSchedule"
    />
    <ModalRegisterReservationStaff
      ref="modal_register_schedule_staff"
      :isEdit="isEditStaffPredetermined"
      @closeModal="refreshSchedule"
    />
    <ModalRegisterReservationFactory
      ref="modal_register_schedule_factory"
      :isEdit="isEditFactoryPredetermined"
      @closeModal="refreshSchedule"
    />
    <ModalGoogleScheduleStaff
      ref="modal_google_schedule_staff"
    />
    <ModalListDeliveryLetter
      ref="listDeliveryLetter"
    />
    <ModalListWorkCertificate
      ref="listWorkCertificate"
    />
  </Layout>
</template>
<style lang="scss">
.custom-card {
  .card-body {
    padding: 1rem 1.25rem;
    .col-sm-auto {
      &.multiple-select-custom {
       min-width: 155px;
       max-width: 300px;
      }
      margin-top: 0.25rem;
      padding-right: calc(var(--bs-gutter-x) / 5);
      padding-left: calc(var(--bs-gutter-x) / 5);
    }
  }
}

.fc {
    .fc-timeline-event.fc-event {
    cursor: pointer;
    margin: 2px 2px;
  }
  .fc-header-toolbar {
    .fc-toolbar-chunk {
      display: flex;
      align-items: center;
    }
  }
  .fc-day-today {
    background-color: #ffffff;
  }
  .fc-event {
    text-align: start;
  }
  .confirm-button-style {
    margin-bottom: 5px;
    height: 26px;
    margin-right: 4px;
    padding: 4px;
  }
  .fc-datagrid-cell-main {
    white-space: pre-wrap;
  }
  .fc-button-active {
    background-color: #045e94 !important;
    border-color: #045e94 !important;
  }
}
.badge {
  white-space: unset;
}
.work-order-type-badge {
  padding: 0.4em 0.5em;
}
.button-collapse {
  position: fixed;
  top: 125px;
  white-space: nowrap;
  right: 0%;
  background-color: #2C3E50;
  color: white;
  height: auto;
  margin: 8px 0 8px 8px;
  padding: 8px 0 10px 10px;
  width: 40px;
  cursor: pointer;
}
.tab-reservations {
  margin: 20px;
  width: 525px;
}
.margin-sm {
  margin-right: 5px;
}
.headline-small {
  font-size: 16px;
    line-height: 1.4;
}
.headline-type-1 {
    -ms-writing-mode: tb-rl;
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
    text-align: center;
    vertical-align: center;
    text-orientation: upright;
    font-feature-settings: initial;
    white-space: nowrap;
    letter-spacing: 10px;
}
.preline { 
    white-space: pre-line; 
}
</style>
